var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.009f6c3b9d0f663e876febecbddc2bec.svg#q';
                    var viewUrl = 'sprites.009f6c3b9d0f663e876febecbddc2bec.svg#view-q';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 25 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };